import React from "react"
import { IncludeExcludeFilter } from "./include_exclude_filter"

const t = (key: string) => window.i18n.t(key)

interface IndustryFilterProps {
  includedValues: string[]
  excludedValues: string[]
  industries: Array<{ id: string; name: string }>
  onChangeIncluded: (values: string[]) => void
  onChangeExcluded: (values: string[]) => void
}

export function IndustryFilter({
  includedValues,
  excludedValues,
  industries,
  onChangeIncluded,
  onChangeExcluded,
}: IndustryFilterProps) {
  return (
    <IncludeExcludeFilter
      label={t("js.back.discover.filters.industry.title")}
      icon="far fa-buildings"
      placeholder={t("js.back.discover.filters.industry.placeholder")}
      tooltip={t("js.back.discover.filters.industry.tooltip")}
      includedValues={includedValues}
      excludedValues={excludedValues}
      allowedValues={industries}
      onChangeIncluded={onChangeIncluded}
      onChangeExcluded={onChangeExcluded}
    />
  )
}
